module.exports = __webpack_public_path__ + "img/soporte.82aab584.gif";